// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__rIdUw","paramInput":"JobSimulator_paramInput__33FQ6","input":"JobSimulator_input__2n_uK"};